export enum eDocumentFeature {
  apiPath = '/pdf-folder',
  pdfFilePath = '/pdf-file',
  auditTaskAddFilePath = '/user-audits/add-file-to-audit-tasks',
}
